import { Button ,Modal} from 'react-bootstrap';
import React, { useEffect, useState }  from 'react';
import "./Supprimer.css"
import $ from 'jquery';
 function Confirmer({handleValider,titre,message,bouton}) {
    const [show, setShow] = useState(false);
  
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
   
    return (
      <>
         <button style={{display:"none"}}  id="modale" onClick={handleShow}>
          Launch demo modal
        </button> 
  
        <Modal show={show} onHide={handleClose}>
          <Modal.Header >
            <Modal.Title>{titre}</Modal.Title>
          </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
          <Modal.Footer>
            <button id="cls"  className="btn btn-warning " onClick={handleClose}>
              Annuler
            </button>
            <button className="btn btn-danger" onClick={handleValider}>
              {bouton}
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  
 export default Confirmer